import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import globalurl from './config/globalurl';
import PhotoUploadPage from './pages/PhotoUploadPage';

// ── Redux Store ───────────────────────────────────────────────────────────────
export const store = configureStore({      // ← export const (not just const)
  reducer: {
    globalurl: globalurl,
  },
});

// ── Root App ──────────────────────────────────────────────────────────────────
export default function App() {
  return (
    <Provider store={store}>
      <PhotoUploadPage />
    </Provider>
  );
}